/**!
 * iscpf - v1.0.6
 * Validate CPF Numbers (for NodeJS and browsers)
 * https://github.com/fdaciuk/iscpf

 * Sat Apr 02 2016 20:17:42 GMT-0300 (BRT)
 * MIT (c) Fernando Daciuk - @fdaciuk
*/
!function (t, n) {
  "use strict";

  "function" == typeof define && define.amd ? define(n) : "object" == typeof exports ? exports = module.exports = n() : t.isCpf = n();
}(this, function () {
  "use strict";

  function t(t) {
    var n = t % 11;
    return 2 > n ? 0 : 11 - n;
  }
  function n(t, n) {
    return t + n;
  }
  function e(t) {
    return function (n, e) {
      return Number(n) * (t - e);
    };
  }
  function r(r) {
    var u = r.match(/^(\d)\1{10}$/);
    if (u) return !1;
    var i = r.match(/^(\d{9})(\d{2})$/),
      c = i[1].split(""),
      o = i[2],
      f = c.map(e(10)).reduce(n),
      a = t(f),
      d = c.concat(a).map(e(11)).reduce(n),
      p = t(d);
    return String(a) + p === o;
  }
  function u(t) {
    var n = String(t).replace(/\D/g, "");
    return 11 === n.length && r(n);
  }
  return u;
});